<template>
	<el-dialog title="修改项目" :visible.sync="sampleVisible" width="820px" center>
		<div class="pjdialog">
			<div class="pjbox" v-for="(item, index) in sampleData" :key="index">
				<span class="pjtitle">{{ item.fieldKey }}</span>
				<el-input v-model="item.fieldValue"></el-input>
			</div>
		</div>
		<span slot="footer" class="dialog-footer"><el-button type="primary" @click="sampleOk">确 定</el-button></span>
	</el-dialog>
</template>

<script>
export default {
	name: 'project',
	data() {
		return {
			sampleVisible: false,
			sampleData: [],
			samplevalue: {}
		};
	},
	mounted() {
		// this.loadData();
	},
	methods: {
		openSample() {
			this.sampleVisible = true;
			console.log(this.sampleData);
		},
		sampleOk() {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.updateSample}`,
				data: {
					prCode: this.$store.state.pr_Code,
					id: this.$store.state.s_Code,
					date: this.sampleData
				},
				cb(res) {
					if (res.result == '111111111111') {
						that.sampleVisible = false;
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.requestraw(params);
			
		}
	}
};
</script>
<style type="text/css" lang="scss" scoped="scoped">
.pjdialog {
	max-height: 560px;
	overflow: auto;
	.pjbox {
		margin-right: 26px;
		margin-bottom: 20px;
		text-align: center;
		display: flex;
		.pjtitle {
			width: 100px;
			margin-right: 20px;
			line-height: 40px;
		}
	}
}
</style>
